// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"877":"css/styles","912":"css/styles-ignore"}[chunkId] + ".css";
};